/**
 * Quizz Presentational Component
 * View: Displays an episode Quizz
 */

import React from 'react';

class RiskAndSensationQuestion extends React.Component {
  render() {
    return <div className="question">
      <div className="container" style={{ backgroundImage: `url('${this.props.background}')` }}>
        {this.createQuestionPage()}
      </div>
    </div>
  }

  createQuestionPage() {
    return <div>
      <p>{this.props.title.split('\n').map((item, key) => {
        return <span key={key}>{item}<br /></span>
      })}</p>
      <button className="default_btn" onClick={this.props.show}>
        Voir La réponse
        <span className="arrow"></span>
      </button>
    </div>
  }
}

RiskAndSensationQuestion.propTypes = {
  background: React.PropTypes.string,
  title: React.PropTypes.string,
  show: React.PropTypes.func
};

RiskAndSensationQuestion.defaultProps = {
  background: "null",
  title: "null",
  show: () => null
};


export default RiskAndSensationQuestion;



// WEBPACK FOOTER //
// ./src/components/riskAndSensation/RiskAndSensationQuestion.js